/** Client-side mirror of packages/rules pricing (missileCost / interceptorCost in rules/src/pricing.ts), read from the live balance. */
import { world } from "./store.svelte";

const r = (x: number) => Math.floor(x + 0.5);

export function missileCost(m: any): number {
  const p = world.balance?.weapons.pricing; if (!p) return 0;
  let c = Math.pow(m.speedIndex, p.missileSpeed.pow) * p.missileSpeed.unit + Math.pow(m.rangeIndex, p.missileRange.pow) * p.missileRange.unit;
  c += m.nuclear ? Math.pow(m.blastRadiusIndex, p.nukeBlastRadius.pow) * p.nukeBlastRadius.unit : Math.pow(m.blastRadiusIndex, p.missileBlastRadius.pow) * p.missileBlastRadius.unit;
  c += Math.pow(m.maxDamageIndex, p.missileMaxDamage.pow) * p.missileMaxDamage.unit;
  if (m.nuclear) c += p.nuclearFee; if (m.tracking) c += p.trackingFee; if (m.ecm) c += p.ecmFee;
  return r(c);
}
export function interceptorCost(i: any): number {
  const p = world.balance?.weapons.pricing; if (!p) return 0;
  return r(Math.pow(i.speedIndex, p.interceptorSpeed.pow) * p.interceptorSpeed.unit + Math.pow(i.rangeIndex, p.interceptorRange.pow) * p.interceptorRange.unit);
}
/** Preparation time after buying: minutes per unit of feature magnitude (rules/src/pricing.ts missileFeatureMagnitude). */
export function missilePrepMin(m: any): number {
  const w = world.balance?.weapons; if (!w) return 0;
  const mag = 1 + m.speedIndex + m.rangeIndex + m.blastRadiusIndex + m.maxDamageIndex + (m.nuclear ? 2 : 0) + (m.tracking ? 1 : 0) + (m.ecm ? 1 : 0);
  return mag * w.pricing.missilePrepPerMagnitudeMin;
}
export function interceptorPrepMin(i: any): number {
  const w = world.balance?.weapons; if (!w) return 0;
  return (1 + i.speedIndex + i.rangeIndex) * w.pricing.interceptorPrepPerMagnitudeMin;
}
